export default __webpack_public_path__ + "static/media/round_arrow.076cc038.svg";